import {
  EventEmitter,
  inject,
  Injectable,
  Output,
  signal,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import {
  I18nSportType,
  ESportsApiV1,
  SportsModel,
  ESportsRoutes,
  ESportsRoutesEN,
} from '../models/sports.model';
import {
  ROUTE_SPORTS,
  ROUTE_SPORTS_EN,
  ROUTE_FOOTBALL,
  ROUTE_FOOTBALL_EN,
  ROUTE_LOTTERY_TORITO,
  ROUTE_LOTTERY_TORITO_EN,
} from '../routes';
import { TranslationService } from './translation.service';
import { ELanguage } from '../utils';
import { RenderModeService } from './render-mode';
import { normalizeRoute } from '@/tools/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class SportsService {
  @Output() sportUpdated = new EventEmitter<{ sport: I18nSportType }>();

  private renderMode = inject(RenderModeService);
  private translateService = inject(TranslateService);
  private translationService = inject(TranslationService);

  private allSportsTraslate = signal<SportsModel[]>([]);

  private nameSportSelected: ESportsApiV1 = ESportsApiV1.FOOTBALL;
  private I18nSelectedSport: I18nSportType = 'Football';

  isNonProd = environment.envName === 'local' || environment.envName === 'dev';

  private sports: Array<SportsModel> = [
    {
      sport: ESportsApiV1.FOOTBALL,
      text: this.translateService.instant('Sports.Football'),
      selected: true,
      route: ROUTE_FOOTBALL,
      icon: 'futbol',
      active: true,
      tracker: 'football',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.BASKETBALL,
      text: this.translateService.instant('Sports.Basket'),
      selected: false,
      // route: 'Basket/todos-los-partidos',
      route: ROUTE_SPORTS.replace(
        ':sport',
        normalizeRoute(ESportsRoutes.BASKETBALL)
      ),
      icon: 'basketball',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.BASEBALL,
      text: this.translateService.instant('Sports.Baseball'),
      selected: false,
      // route: 'Beisbol/todos-los-partidos',
      route: ROUTE_SPORTS.replace(
        ':sport',
        normalizeRoute(ESportsRoutes.BASEBALL)
      ),
      icon: 'baseball',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.VOLLEYBALL,
      text: this.translateService.instant('Sports.Voleyball'),
      selected: false,
      // route: 'Voleibol/todos-los-partidos',
      route: ROUTE_SPORTS.replace(
        ':sport',
        normalizeRoute(ESportsRoutes.VOLLEYBALL)
      ),
      icon: 'volleyball',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.HOCKEY,
      text: this.translateService.instant('Sports.Hockey'),
      selected: false,
      // route: 'Hockey/todos-los-partidos',
      route: ROUTE_SPORTS.replace(
        ':sport',
        normalizeRoute(ESportsRoutes.HOCKEY)
      ),
      icon: 'icehockey',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.HANDBALL,
      text: this.translateService.instant('Sports.Handball'),
      selected: false,
      // route: 'Balonmano/todos-los-partidos',
      route: ROUTE_SPORTS.replace(
        ':sport',
        normalizeRoute(ESportsRoutes.HANDBALL)
      ),
      icon: 'handball',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.AMERICAN_FOOTBALL,
      text: this.translateService.instant('Sports.AmericanFutbol'), //'Soccer A.',
      selected: false,
      // route: 'FutbolAmericano/todos-los-partidos',
      route: ROUTE_SPORTS.replace(
        ':sport',
        normalizeRoute(ESportsRoutes.AMERICAN_FOOTBALL)
      ),
      icon: 'football',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.GANADAZO,
      text: this.translateService.instant('Sports.Ganadazo'), //'T. Ganadazo',
      selected: false,
      route: ROUTE_LOTTERY_TORITO,
      icon: 'torito',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
  ].filter(Boolean);

  private sportsEn: Array<SportsModel> = [
    {
      sport: ESportsApiV1.FOOTBALL,
      text: this.translateService.instant('Sports.Football'),
      selected: true,
      route: ROUTE_FOOTBALL_EN,
      icon: 'futbol',
      active: true,
      tracker: 'football',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.BASKETBALL,
      text: this.translateService.instant('Sports.Basket'),
      selected: false,
      // route: 'Basket/todos-los-partidos',
      route: ROUTE_SPORTS_EN.replace(
        ':sport',
        normalizeRoute(ESportsRoutesEN.BASKETBALL)
      ),
      icon: 'basketball',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.BASEBALL,
      text: this.translateService.instant('Sports.Baseball'),
      selected: false,
      // route: 'Beisbol/todos-los-partidos',
      route: ROUTE_SPORTS_EN.replace(
        ':sport',
        normalizeRoute(ESportsRoutesEN.BASEBALL)
      ),
      icon: 'baseball',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.VOLLEYBALL,
      text: this.translateService.instant('Sports.Voleyball'),
      selected: false,
      // route: 'Voleibol/todos-los-partidos',
      route: ROUTE_SPORTS_EN.replace(
        ':sport',
        normalizeRoute(ESportsRoutesEN.VOLLEYBALL)
      ),
      icon: 'volleyball',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.HOCKEY,
      text: this.translateService.instant('Sports.Hockey'),
      selected: false,
      // route: 'Hockey/todos-los-partidos',
      route: ROUTE_SPORTS_EN.replace(
        ':sport',
        normalizeRoute(ESportsRoutesEN.HOCKEY)
      ),
      icon: 'icehockey',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.HANDBALL,
      text: this.translateService.instant('Sports.Handball'),
      selected: false,
      // route: 'Balonmano/todos-los-partidos',
      route: ROUTE_SPORTS_EN.replace(
        ':sport',
        normalizeRoute(ESportsRoutesEN.HANDBALL)
      ),
      icon: 'handball',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.AMERICAN_FOOTBALL,
      text: this.translateService.instant('Sports.AmericanFutbol'), //'Soccer A.',
      selected: false,
      // route: 'FutbolAmericano/todos-los-partidos',
      route: ROUTE_SPORTS_EN.replace(
        ':sport',
        normalizeRoute(ESportsRoutesEN.AMERICAN_FOOTBALL)
      ),
      icon: 'football',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
    {
      sport: ESportsApiV1.GANADAZO,
      text: this.translateService.instant('Sports.Ganadazo'), //'T. Ganadazo',
      selected: false,
      route: ROUTE_LOTTERY_TORITO_EN,
      icon: 'torito',
      active: true,
      tracker: '',
      urlIcon: environment.urlSport + 'football.png',
    },
  ].filter(Boolean);

  // {
  //   sport: 'Tenis',
  //   text: this.translateService.instant('Sports.Tennis'),
  //   selected: false,
  //   route: 'Tenis/todos-los-partidos',
  //   icon: 'tennis',
  //   active: true,
  //   tracker: '',
  //   urlIcon: environment.urlSport + 'football.png',
  // },

  // {
  //   sport: 'Ganadazo',
  //   text: this.translateService.instant('Sports.Ganadazo'), //'T. Ganadazo',
  //   selected: false,
  //   route: 'loteriaToritoGanadazo',
  //   icon: 'ganadazo',
  //   active: true,
  //   tracker: '',
  //   urlIcon: environment.urlSport + 'football.png',
  // },
  // {
  //   sport: 'Megamillions',
  //   text: this.translateService.instant('Sports.Megamillions'), //'T. Mega Millions',
  //   selected: false,
  //   route: 'loteriaToritoMegamillions',
  //   icon: 'mega-millions',
  //   active: true,
  //   tracker: '',
  //   urlIcon: environment.urlSport + 'football.png',
  // },

  constructor() {
    if (this.renderMode.isBrowser()) {
      if (this.translationService.getCurrentLanguage() === ELanguage.EN)
        this.allSportsTraslate.set(this.sportsEn);
      else this.allSportsTraslate.set(this.sports);
    }
  }

  setSelectedSport(selected: ESportsApiV1) {
    // this.sports = this.sports.map((sport) => {
    //   if (sport.sport === selected) {
    //     return { ...sport, selected: true };
    //   } else return { ...sport, selected: false };
    // });

    this.allSportsTraslate.update((allSports) =>
      allSports.map((sport) => {
        if (sport.sport === selected) {
          return { ...sport, selected: true };
        } else return { ...sport, selected: false };
      })
    );
    // if (this.nameSportSelected !== selected) {
    //   switch (selected) {
    //     case 'Futbol':
    //       this.I18nSelectedSport = 'Football';
    //       break;
    //     case 'Basket':
    //       this.I18nSelectedSport = 'Basket';
    //       break;
    //     case 'Beisbol':
    //       this.I18nSelectedSport = 'Baseball';
    //       break;
    //     case 'Voleibol':
    //       this.I18nSelectedSport = 'Volleyball';
    //       break;
    //     case 'Hockey':
    //       this.I18nSelectedSport = 'Hockey';
    //       break;
    //     case 'Balonmano':
    //       this.I18nSelectedSport = 'HandBall';
    //       break;
    //     case 'FutbolAmericano':
    //       this.I18nSelectedSport = 'AmericanFootball';
    //       break;
    //     case 'Tenis':
    //       this.I18nSelectedSport = 'Tennis';
    //       break;
    //     default:
    //       this.I18nSelectedSport = 'Football';
    //       break;
    //   }

    //   this.sportUpdated.emit({ sport: this.I18nSelectedSport });
    // }

    // this.nameSportSelected = selected;

    this.nameSportSelected = selected;

    switch (selected) {
      case ESportsApiV1.FOOTBALL:
        this.I18nSelectedSport = 'Football';
        break;
      case ESportsApiV1.BASKETBALL:
        this.I18nSelectedSport = 'Basket';
        break;
      case ESportsApiV1.BASEBALL:
        this.I18nSelectedSport = 'Baseball';
        break;
      case ESportsApiV1.VOLLEYBALL:
        this.I18nSelectedSport = 'Volleyball';
        break;
      case ESportsApiV1.HOCKEY:
        this.I18nSelectedSport = 'Hockey';
        break;
      case ESportsApiV1.HANDBALL:
        this.I18nSelectedSport = 'HandBall';
        break;
      case ESportsApiV1.AMERICAN_FOOTBALL:
        this.I18nSelectedSport = 'AmericanFootball';
        break;
      case ESportsApiV1.TENNIS:
        this.I18nSelectedSport = 'Tennis';
        break;
      case ESportsApiV1.GANADAZO:
        this.I18nSelectedSport = 'Ganadazo';
        break;
      default:
        this.I18nSelectedSport = 'Football';
        break;
    }

    this.sportUpdated.emit({
      sport: this.I18nSelectedSport,
    });
  }

  getSelectedSport(): ESportsApiV1 {
    const index = this.selectedSportIndex();
    if (index > 7 || index < 0) {
      return ESportsApiV1.FOOTBALL;
    }
    return this.nameSportSelected;
  }

  getSports(): Array<SportsModel> {
    return this.allSportsTraslate();
  }

  selectedSportIndex(): number {
    return this.allSportsTraslate().findIndex((elem: any) => elem.selected);
  }

  getI18nSport(): I18nSportType {
    return this.I18nSelectedSport;
  }

  searchSport(sport: ESportsApiV1): SportsModel {
    return (
      this.allSportsTraslate().find((elem: any) => elem.sport === sport) ||
      this.sports[0]
    );
  }

  sportSearchText(): string {
    return (
      this.allSportsTraslate().find(
        (elem: any) => elem.sport === this.getSelectedSport()
      )?.icon || 'futbol'
    );
  }
}
